var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E4EDF2;}\n\t.st1{fill:#F25949;}\n\t.st2{fill:#393B3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,11.97v13.96C2,28.18,3.82,30,6.07,30h19.86c2.25,0,4.07-1.82,4.07-4.07V11.97H2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,3.96h-5.5v2.959c0,0.552-0.447,1-1,1s-1-0.448-1-1V3.96h-11v2.959c0,0.552-0.448,1-1,1s-1-0.448-1-1V3.96   H3c-0.55,0-1,0.45-1,1v7.01h28V4.96C30,4.41,29.55,3.96,29,3.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.5,7.919c0.552,0,1-0.448,1-1V3.96V3c0-0.552-0.448-1-1-1s-1,0.448-1,1v0.96v2.959   C8.5,7.472,8.948,7.919,9.5,7.919z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.5,7.919c0.553,0,1-0.448,1-1V3.96V3c0-0.552-0.447-1-1-1s-1,0.448-1,1v0.96v2.959   C21.5,7.472,21.947,7.919,22.5,7.919z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.e1f3dc933f870fa03f2fa6d2c10202f3.svg";
export { ForwardRef as ReactComponent };